module.exports = __webpack_public_path__ + "c8116263cfe619e8a146290b6a45bb38.jpeg";